export const Footer = () => {
    return (
        <>
            <footer>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </footer>
        </>
    );
};
